import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 15px;
  text-align: center;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const ImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  padding: 5px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 7px;

  img {
    object-fit: contain;
  }
`;

export const Names = styled.div`
  flex: auto;
`;

export const SubCategory = styled(Typography.Body)`
  margin-bottom: 2px;
`;

export const Category = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Stats = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;
  padding: 5px 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 7px;
`;

export const Stat = styled(Typography.Title)<{ $isRed?: boolean }>`
  color: ${({ theme, $isRed }) =>
    $isRed ? theme.palette.system.red : theme.palette.primary.labels};
`;

export const Body = styled.div`
  padding-left: 50px;
`;

export const BodySpan = styled(Typography.Body)<{ $isRed?: boolean }>`
  color: ${({ theme, $isRed }) =>
    $isRed ? theme.palette.system.red : theme.palette.primary.labels};
`;
